import { get } from '../rest';

export default {
  index: params => get('/admin/dashboard', params),
};
